import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HeaderButton } from 'libs/abc/queries/opath/core/src/lib/viewModels/layout.viewModel';
import { OPathOperator, OperatorPosition } from '../../models/operators.model';
import { TranslationConfiguration } from '../../models/view.model';
import { OperatorsService } from '../../services/operators.service';
import { SharedService } from '../../services/shared.service';
@Component({
    selector: 'expressions-editor-operators',
    templateUrl: './operators.component.html',
    styleUrls: ['./operators.component.scss'],
    standalone: false
})
export class OperatorsComponent implements OnInit {
  @Output() onChangePosition: EventEmitter<OperatorPosition> = new EventEmitter<OperatorPosition>();
  @Output() onOperatorSelected: EventEmitter<OPathOperator> = new EventEmitter<OPathOperator>();
  @Output() ontoggleOperatorPermenetly: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() width: number;
  @Input() height: number;
  @Input() position: OperatorPosition;
  public OperatorPosition = OperatorPosition;
  public oPathOperators: OPathOperator[] = [];
  public showOperatorsPermanently: boolean = false;
  public translation: TranslationConfiguration;
  public operatorButtons: HeaderButton[] = [];

  constructor(private operatorsService: OperatorsService, private sharedService: SharedService) {
    this.translation = sharedService.translation;
  }

  public ngOnInit(): void {
    this.oPathOperators = this.operatorsService.oPathOperators;
    this.operatorButtons = [
      {
        icon: 'pin',
        toolTipContent: this.translation?.pin,
        statfullButton: true,
        active: this.showOperatorsPermanently,
        action: async () => this.changePosition(OperatorPosition.left),
      },
    ];
  }
  public onOperatorClick(operator: OPathOperator): void {
    this.onOperatorSelected.emit(operator);
  }
  public toggleShowOperatorsPermanently(): void {
    this.showOperatorsPermanently = !this.showOperatorsPermanently;
    this.ontoggleOperatorPermenetly.emit(this.showOperatorsPermanently);
  }

  public changePosition(position: OperatorPosition): void {
    this.onChangePosition.emit(position);
  }
}
